import { defineMessages } from 'react-intl';

export default defineMessages({
  comments: {
    id: 'simulated.questions.logHistory.comments',
    defaultMessage: 'Comments',
  },
  history: {
    id: 'simulated.questions.logHistory.history',
    defaultMessage: 'History',
  },
  addedBy: {
    id: 'simulated.questions.logHistory.addedBy',
    defaultMessage: 'Added by',
  },
});
